export class ListIngestionPipelinesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListIngestionPipelinesFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortIngestionPipelineBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListIngestionPipelinesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
